import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "config/api";
import { API_ROUTES } from "config/apiRoutes";

/**
 * @description Dispatch this thunk to show upload a file to S3.
 */
export const uploadFile = createAsyncThunk(
  "files/uploadFile",
  async (file: File, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      const { data } = await API.post(
        API_ROUTES.FILES.UPLOAD(),
        formData,
        config,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
